import type { Project } from '@timato/shared';
import { cn } from '@/lib/cn';
import { projectColor } from '@/lib/projectColors';

type Props = { project: Pick<Project, 'color'> | null | undefined; size?: number; /** Rounded square on Projects cards and headings; a circle in lists (4b vs 7a). */ square?: boolean; className?: string };

export function ProjectDot({ project, size = 8, square = false, className }: Props) {
  return (
    <span aria-hidden="true" className={cn('inline-block shrink-0', className)}
      style={{ width: size, height: size, borderRadius: square ? Math.max(3, Math.round(size * 0.3)) : '50%', background: project ? projectColor(project) : 'var(--color-empty-slot)' }} />
  );
}
